import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../api';

export const serviceSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'service',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },
    },
});

export default serviceSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } = serviceSlice.actions;

// Public Selectors
export const selectServiceData = (state) => state.service.data;
export const selectServiceStatus = (state) => state.service.status;
export const selectServiceError = (state) => state.service.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getServices', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(
            initialize({
                records: result.data?.map((item) => {
                    return {
                        ...item,
                        actions: [{ name: 'Schedule Call' }],
                    };
                }),
            })
        );
    } else {
        dispatch(error(result.errorMessage));
    }
};
